/* eslint-disable @typescript-eslint/no-unused-vars */
// TODO: Fix unused variables

import { useEffect, useMemo, useState } from 'react';
import { ENCODED_FILTER_SEL_PAR } from '../../../components/filters/hooks/filter-names.constants';
import { useAppFavouriteList } from '../../../hooks/filters/use-app-favourite.hook';
import { H_LS_KEY } from '../../../services/get-favourite.service';
import { IMAGES_REPO } from '../../../static-resources/home-image-repo';
import { PATH_TAGS } from '../../../static-resources/static-misc';
import { HomeSlideCardComponentProps } from '../components/home-slide-card.component';

export const useCapabilities = () => {
  const { list } = useAppFavouriteList(H_LS_KEY);
  const [cards, setCards] = useState<HomeSlideCardComponentProps[]>([]);
  const tools = useTools();
  const [recentVisits, setRecentVisits] = useState<
    HomeSlideCardComponentProps[]
  >([]);

  useEffect(() => {
    if (list && list.length > 0) {
      setRecentVisits(
        list
          .sort((a, b) => (a.date > b.date ? -1 : 1))
          .map((i) => {
            const { path } = i;
            const defTag =
              PATH_TAGS[path] && PATH_TAGS[path].length > 0
                ? PATH_TAGS[path][0]
                : undefined;
            const src = defTag?.src ? defTag.src : '';

            const href = `${i.path}?${ENCODED_FILTER_SEL_PAR}=${i.encoded}`;
            const description =
              i.tags && i.tags.length > 0 ? i.tags[0].description : '';

            return {
              description,
              title: i.title,
              href,
              tags: i.tags,
              src,
              linkSrc: IMAGES_REPO.icon001,
            };
          }),
      );
    }
  }, [list]);

  useEffect(() => {
    if (recentVisits && recentVisits.length > 0) {
      setCards(recentVisits.concat(tools));
    } else {
      setCards(tools);
    }
  }, [recentVisits, tools]);

  return cards;
};

export const useTools = () => {
  const cards: HomeSlideCardComponentProps[] = useMemo(() => {
    const l = Object.entries(PATH_TAGS).flatMap(([key, i]) => i);

    return l.map((i) => {
      const description = i.description;
      const title = i.title;
      const src = `${i.src}`;
      const href = `${i.href}`;
      const tags: { title: string; description: string; href: string }[] = [];
      tags.push({ title, description: '', href });

      return {
        description,
        title,
        href,
        tags,
        src,
        linkSrc: IMAGES_REPO.icon001,
      };
    });
  }, []);

  return cards;
};

export const useFindTool = (title: string) => {
  const tools: HomeSlideCardComponentProps[] = useTools();
  const tool = useMemo(() => {
    return tools.find((i) => i.title.toLowerCase() === title.toLowerCase());
  }, [tools, title]);

  return tool;
};
